export type ArmorPurchaseConfig = {
  minQuantity: number;
  maxQuantity: number | null;
};

export type ArmorVariantOption = {
  value: string;
  dataset: { price?: string; sellingPlan?: string };
};

/** What the row shows and submits for the picked option. Nothing picked shows the lowest price. */
export function armorVariantSelection(option: ArmorVariantOption | null, fromPrice: string) {
  const picked = !!option?.value;
  return {
    price: picked ? option.dataset.price || fromPrice : fromPrice,
    sellingPlan: picked ? option.dataset.sellingPlan || "" : "",
  };
}

export function clampQuantity(
  quantity: number,
  maxQuantity: number | null,
  minQuantity = 1,
): number {
  const min = minQuantity > 0 ? minQuantity : 1;
  if (Number.isNaN(quantity) || quantity < min) return min;
  if (maxQuantity == null || maxQuantity < min) return quantity;
  const max = maxQuantity > 0 ? maxQuantity : min;
  return Math.min(quantity, max);
}

export function parseArmorPurchaseConfig(root: HTMLElement): ArmorPurchaseConfig | null {
  const script = root.querySelector<HTMLScriptElement>("[data-armor-purchase-config]");
  if (!script?.textContent) return null;

  try {
    return JSON.parse(script.textContent) as ArmorPurchaseConfig;
  } catch {
    return null;
  }
}
